import "./developer-preview.scss";
import {useNavigate} from "react-router-dom";
import {PropertyFilters} from "../../../shared/types/filters";

interface DeveloperPreviewProps {
    id: number | null;
    name: string;
    description: string;
    logo_url: string;

}

function DeveloperPreview({ id, name, description, logo_url }: DeveloperPreviewProps) {

    const navigate = useNavigate();

    const navigateToProperties = () => {
        const developerID = id ?? 0
        const propertyFilters: PropertyFilters = {
            name: "",
            page: 1,
            page_size: 100,
            developer_ids: [developerID]
        }
        const queryString = encodeURIComponent(JSON.stringify(propertyFilters));
        // navigate("/properties", { state: { developer_id: id, developer_name: name, developer_description: description, developer_logo_url: logo_url }});
        navigate(`/property/list?filters=${queryString}`);
    }

    return (
        <div className="card developer-preview">
            <button className={"developer-card-btn"}
                    style={{backgroundImage: `url(${logo_url})`}}
                    onClick={navigateToProperties}>
                <h4 className={"developer-card-name"}>{name.toUpperCase()}</h4>
            </button>
        </div>
    );
}

export default DeveloperPreview;